import { render, staticRenderFns } from "./bullLocationWiseSemenStorage.vue?vue&type=template&id=2552fa7d&scoped=true&"
import script from "./bullLocationWiseSemenStorage.vue?vue&type=script&lang=js&"
export * from "./bullLocationWiseSemenStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2552fa7d",
  null
  
)

export default component.exports